import * as types from '../../../../../constants/ActionNameConstants';

const INITIAL_STATE = {
  loading: false,
  data: null,
  error: null,
};

const SaveFileMergeStatusCGAReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SAVE_FILE_MERGE_STATUS_CGA_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };
    case types.SAVE_FILE_MERGE_STATUS_CGA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case types.SAVE_FILE_MERGE_STATUS_CGA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: null,
      };
    default:
      return state;
  }
};

export default SaveFileMergeStatusCGAReducer;
